import React from 'react'
import ModalContent from '../../../components/modals/modal_content'
import FlatButton from '../../../components/buttons/flat_button'

interface DeleteMessageModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  messageContent: string
}

const DeleteMessageModal: React.FC<DeleteMessageModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  messageContent,
}) => {
  if (!isOpen) return null

  // モーダルの背景をクリックしたら閉じる
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  // メッセージ内容を3行まで表示、それ以上は省略
  const truncateMessage = (text: string) => {
    const lines = text.split('\n')
    if (lines.length > 3) {
      return lines.slice(0, 3).join('\n') + '...'
    }
    // 文字数が長い場合も省略
    if (text.length > 150) {
      return text.substring(0, 150) + '...'
    }
    return text
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <ModalContent
          title="メッセージを削除"
          onClose={onClose}
          className="w-full max-w-md"
        >
          <div className="p-6">
            <div className="mb-6">
              <p className="text-sm text-main-darkgray mb-3">
                このメッセージを削除してもよろしいですか？
              </p>
              <div className="bg-main-lightgray p-4 rounded-lg mb-4">
                <p className="text-sm whitespace-pre-wrap break-words">
                  {truncateMessage(messageContent)}
                </p>
              </div>
              <p className="text-xs text-main-red">※この操作は取り消せません</p>
            </div>

            <div className="flex gap-3 justify-center">
              <FlatButton onClick={onClose} outline type="button">
                キャンセル
              </FlatButton>
              <FlatButton
                onClick={onConfirm}
                type="button"
                className="bg-main-red"
              >
                削除する
              </FlatButton>
            </div>
          </div>
        </ModalContent>
      </div>
    </div>
  )
}

export default DeleteMessageModal
